import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ToastProvider from "./components/ToastProvider";
import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import ContactPage from "./pages/ContactPage";
import FaqPage from "./pages/FaqPage";
import DeliveryPage from "./pages/DeliveryPage";
import CertificatePage from "./pages/CertificatePage";
import IndividualOrderPage from "./pages/IndividualOrderPage";
import PublicOfferPage from "./pages/PublicOfferPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminPage from "./pages/admin/AdminPage";
import ProtectedRoute from "./pages/admin/ProtectedRoute";
import PaymentResult from "./pages/PaymentResult";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <ToastProvider>
            <Routes>
              {/* Admin login (no sidebar/header) */}
              <Route path="/admin/login" element={<AdminLogin />} />

              {/* Admin panel (protected, no public header/footer) */}
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />

              {/* Public pages */}
              <Route
                path="/*"
                element={
                  <>
                    <ScrollToTop />
                    <Header />
                    <main>
                      <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/catalog" element={<CatalogPage />} />
                        <Route path="/product/:id" element={<ProductPage />} />
                        <Route path="/cart" element={<CartPage />} />
                        <Route path="/checkout" element={<CheckoutPage />} />
                        <Route path="/payment/result" element={<PaymentResult />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/faq" element={<FaqPage />} />
                        <Route path="/delivery" element={<DeliveryPage />} />
                        <Route path="/certificate" element={<CertificatePage />} />
                        <Route path="/individual-order" element={<IndividualOrderPage />} />
                        <Route path="/public-offer" element={<PublicOfferPage />} />
                      </Routes>
                    </main>
                    <Footer />
                  </>
                }
              />
            </Routes>
          </ToastProvider>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
